import moment from "moment-timezone";
import { useEffect, useState } from "react";
import { CSVLink } from "react-csv";
import { FaFileCsv } from "react-icons/fa";
import { FilterVariants, TABLE_COLUMNS } from "../../utils/typings";

interface CSVProps {
  data: any[];
}

export const CSVDownload = ({ data }: CSVProps) => {
  const [csvData, setCsvData] = useState<any>(data);
  const labels = Object.values(TABLE_COLUMNS).map((column) => column.label);
  const values = data.map((item: any) => {
    return Object.keys(TABLE_COLUMNS).map((id: string, index) => {
      if (Object.values(TABLE_COLUMNS)[index].type === FilterVariants.Date)
        return moment
          .tz(item[id], moment.tz.guess())
          .format("MMM DD, YYYY HH:MM A z");

      return item[id];
    });
  });

  useEffect(() => {
    if (data.length) {
      const formattedCSV = [labels, ...values];
      setCsvData(formattedCSV);
    }
  }, [data]);

  return (
    <CSVLink data={csvData} download={`almond-${new Date().toISOString()}.csv`}>
      <FaFileCsv size="25px" color="#54565a" style={{ margin: "auto" }} />
    </CSVLink>
  );
};
